import API from "@/services/api";

export enum Endpoints {
  FetchPdf = "/contracts/electronic_notification_pdf/",
}

export const fetchElectronicNotificationPdf = () => {
  return new Promise<Blob>(async (resolve, reject) => {
    API.get<Blob>({
      endpoint: Endpoints.FetchPdf,
      versions: [1],
      config: { responseType: 'blob' }
    })
    .then(res => {
      resolve(res.promise.data)
    })
    .catch(err => {
      reject(err);
    })
  })
}